import styled from 'styled-components'

import { FontPreset, FontStyle, TFontStyleMixin } from '../styles/mixins'
import { Text } from './Text'

export const FilterText = styled(Text)<TFontStyleMixin>`
  ${FontPreset('paragraph opensans')};
  ${(props) =>
    FontStyle({
      ...props,
    })}
`
